jQuery(document).ready(function(){
  var slideout = new Slideout({
    //'panel': document.getElementById('PageContainer'),
    'panel': document.getElementsByClassName('slide_menu')[0],
    'menu': document.getElementById('drawer-nav'),
    'padding': 500,
    'side': 'left'
  });
  slideout.disableTouch();
  document.querySelector('.js-slideout-toggle').addEventListener('click', function() {
    slideout.toggle();
  });

  function close(eve) {
    eve.preventDefault();
    slideout.close();
  }

  slideout
  .on('beforeopen', function() {
    this.panel.classList.add('panel-open');
    jQuery('.js-slideout-toggle').addClass('active');
    jQuery('.d-overlay').addClass('active');
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
      jQuery('body, html').css('position', 'fixed');
    }

  })
  .on('open', function() {
    this.panel.addEventListener('click', close);
  })
  .on('beforeclose', function() {
    this.panel.classList.remove('panel-open');
    this.panel.removeEventListener('click', close);
    jQuery('.js-slideout-toggle').removeClass('active');
    jQuery('.d-overlay').removeClass('active');
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
      jQuery('body, html').css('position', 'inherit');
    }
  });

  Scroll();

  jQuery(window).resize(function(){
    Scroll();

  });


//   jQuery('.parent a.').click(function(){
//     var $this = jQuery(this);

//     if ($this.hasClass('active')) {
//       $this.removeClass('active');
//       $this.next().slideUp(350);
//     } 
//     else {
//       $this.parent().parent().find('a').removeClass('active');
//       $this.parent().parent().find('.drawer-subnav').slideUp(350);
//       $this.toggleClass('active');
//       $this.next().slideToggle(350);
//     }
//   });
  jQuery('.parent a.anchor_under_parent').click(function(){
     var $this = jQuery(this);
     $this.toggleClass('active');
     jQuery('body').addClass('submenu_opened');
  });
  jQuery('.back-button').click(function(){
    var this_is = jQuery(this);
    this_is.parent().parent().find('.anchor_under_parent').removeClass('active');
    jQuery('body').removeClass('submenu_opened');
  });
  
  // For mobile navigation bar
//     jQuery('.having_submenu').click(function() {
//       var mob_menu_attr = jQuery(this).attr('data-href');
//       jQuery('.nav-icon.js-slideout-toggle').trigger('click');
//       if(!jQuery('body').hasClass('submenu_opened')){
//         jQuery('body').addClass('submenu_opened');
//       }
//       setTimeout(function(){
//         jQuery('.parent-nav li.parent').each(function(){
//           var sub_menu_attr = jQuery(this).find('a').attr('data-attr');
//           if(sub_menu_attr == mob_menu_attr){
//              jQuery(this).find('.anchor_under_parent').addClass('active');
//              jQuery(this).siblings().find('.anchor_under_parent').removeClass('active'); 
//           }
//         });
//       },500);
//     });
});


function Scroll(){
  // var dHeight = jQuery(window).height() - jQuery(".drawer-nav a.d-logo").height() - 15;


  // jQuery(".drawer-nav .parent-nav").height(dHeight);

  // if(jQuery(".drawer-nav .parent-nav").height() > jQuery(window).height()){
  //   jQuery(".drawer-nav .parent-nav").css('overflow-y', 'auto');

  // }

}
